<template>
  <v-col>
    <v-row
      class="d-flex justify-center"
      style="margin-top: 20px; margin-bottom: 20px"
    >
      <v-data-table
        :headers="headers_droits"
        :items="droits"
        class="elevation-1"
        :item-class="colorationSelection"
        pagination.sync="pagination"
        item-key="id"
        dense
        v-if="droits"
        sort-by="droit"
        @click:row="openDroits"
        :footer-props="{ 'items-per-page-options': [20, 50, -1] }"
      >
      </v-data-table>

      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <div class="text-center">
          <v-progress-circular :value="20"></v-progress-circular>
        </div>
      </v-dialog>
      <v-data-table
        :headers="headers_individus"
        :items="utilisateurs"
        class="elevation-1"
        pagination.sync="pagination"
        item-key="id"
        dense
        :footer-props="{ 'items-per-page-options': [20, 50, -1] }"
        v-if="utilisateurs"
        sort-by="user"
      >
        <template v-slot:[`item.acces`]="{ item }">
          <v-checkbox
            class="my-n4 py-n4"
            dense
            :input-value="item.acces"
            :disabled="!rowSelected"
            @change="change(item)"
          ></v-checkbox>
        </template>
      </v-data-table>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn color="success" @click="sauvegarde()" :disabled="!rowSelected"
          >Sauvegarder l'ajout du droit sélectionné pour les utilisateurs</v-btn
        >
      </v-col>
      <v-progress-circular v-if="loading"></v-progress-circular>
    </v-row>
  </v-col>
</template>

<script>
import ApiUtilisateurRepository from "@/repositories/ApiUtilisateurRepository";
import ApiDroitRepository from "@/repositories/ApiDroitRepository";

export default {
  components: {},
  data() {
    return {
      headers_individus: [
        { text: "Nom", value: "nom", align: "center" },
        { text: "Prénom", value: "prenom", align: "center" },
        { text: "Oui / Non ?", value: "acces", align: "center" },
      ],
      headers_droits: [
        { text: "Nom Structure", value: "libelleStruture", align: "center" },
        { text: "Code Structure", value: "codeStructure", align: "center" },
      ],
      individus: [],
      utilisateurs: null,
      droits: null,
      calc: null,
      dialog: false,
      dialogAjout: false,
      users: [],
      user: null,
      name: null,
      ajoutValid: false,
      search: null,
      rowSelected: null,
      loading: false,
    };
  },
  async mounted() {
    //chargement des droits puis users pour ne pas d'erreur ( ne pas utiliser await)
    this.loadDroits();
    this.loadUsers();
  },
  methods: {
    async loadDroits() {
      this.droits = await ApiDroitRepository.getDroits();
    },
    async loadUsers() {
      this.utilisateurs = await ApiUtilisateurRepository.getUtilisateurs();
    },
    async openDroits(row) {
      this.utilisateurs.forEach((utilisateur) => {
        utilisateur.acces = false;
      });
      this.rowSelected = row;
      this.utilisateurs.forEach((utilisateur) =>
        row.users.forEach((element) => {
          // console.log(element.id);
          // console.log(utilisateur.id);
          // console.log(element.id === utilisateur.id);
          if (utilisateur.acces === true || element.id === utilisateur.id)
            utilisateur.acces = true;
          else utilisateur.acces = false;
        })
      );
      //console.log(this.utilisateurs);
    },
    change(item) {
      console.log(this.rowSelected);
      item.acces = !item.acces;
      // ajout du droit
      if (item.acces && !this.rowSelected.users.includes(item)) {
        this.rowSelected.users.push(item);
      }
      // supression du droit
      // fonction de recherche de id de l'item
      const findIndenItem = (element) => element.id == item.id;
      if (!item.acces) {
        let index = this.rowSelected.users.findIndex(findIndenItem);
        console.log(index);
        if (index !== -1) {
          this.rowSelected.users.splice(index, 1);
        }
      }
      console.log(this.rowSelected);
    },
    sauvegarde() {
      // this.rowSelected.users.forEach((utilisateur) => {
      //   delete utilisateur.acces;
      // });
      console.log(this.rowSelected);
      this.$confirm(
        "<strong>ATTENTION, en cliquant sur oui, vous validez votre choix</strong>"
      ).then(async (reponse) => {
        if (reponse) {
          this.loading = true;
          await ApiDroitRepository.saveDroit(this.rowSelected);
          this.loading = false;
        }
      });
    },
    colorationSelection(item) {
      if (
        this.rowSelected &&
        item.codeStructure === this.rowSelected.codeStructure
      ) {
        return "grey";
      } else {
        return "";
      }
    },
  },
};
</script>
